import { useFieldValidity } from '../../../pages/ApplicationV3/hooks/useFieldValidity';
import { useFormContext } from 'react-hook-form';
import classNames from 'classnames';
import styles from './Textarea.module.scss';

export const Cypress_data = {
  textarea: 'base-textarea',
  wrapper: 'base-textarea-wrapper',
  label: 'base-textarea-label',
  counter: 'base-textarea-counter',
};

interface TextareaProps {
  name: string;
  label: string;
  placeholder?: string;
  required?: boolean;
  rows?: number;
  max?: number; // Ny optional prop för max tecken
}

const Textarea = ({
  name,
  label,
  placeholder,
  required,
  rows = 4,
  max,
}: TextareaProps) => {
  const { register, watch } = useFormContext();
  const { isValid, invalid, error } = useFieldValidity(name);
  const value = watch(name) || '';
  const charCount = value.length;

  return (
    <div data-cy={Cypress_data.wrapper} className={styles.wrapper}>
      <label
        className={styles.label}
        htmlFor={name}
        data-cy={Cypress_data.label}
      >
        {label}
      </label>
      <textarea
        id={name}
        {...register(name)}
        name={name}
        placeholder={placeholder}
        value={value}
        required={required}
        rows={rows}
        maxLength={max}
        className={classNames(styles.textarea, {
          [styles.isValid]: isValid,
          [styles.isInvalid]: invalid,
        })}
        data-cy={Cypress_data.textarea}
      />
      {max && (
        <span className={styles.counter} data-cy={Cypress_data.counter}>
          {charCount} / {max}
        </span>
      )}
      {error && <span className={styles.errorText}>{error.message}</span>}
    </div>
  );
};

export default Textarea;
